<template>
  <div>
    <load-profile />
    <!-- Table Container Card -->
    <b-card>
      <validation-observer
        ref="editForm"
        #default="{ invalid }"
      >
        <!-- form -->
        <n-form-confirmation
          key="editForm"
          :form="$refs.editForm"
          :disabled="invalid"
          @submit="submit"
        >
          <n-input
            v-model="data"
            :fields="fields"
            :init-value="initData"
          >
            <template #file="item">
              <b-form-group
                :label-for="item.field.key"
                class="fightResult"
              >
                <validation-provider
                  #default="{ errors, validate }"
                  :vid="item.field.key"
                  :name="$t(item.field.label)"
                  :rules="item.field.rules"
                >
                  <label>
                    {{ $t(item.field.label) }}
                  </label>
                  <div>
                    <input
                      id="assetsFieldHandle"
                      ref="fileInput"
                      type="file"
                      :name="item.field.key"
                      accept=".mp4"
                      @change="onChange($event, item.field.key, validate)"
                    >
                  </div>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </template>
            <template #result="item">
              <b-form-group
                :label-for="item.field.key"
                class="fightResult"
              >
                <validation-provider
                  #default="{ errors }"
                  :vid="item.field.key"
                  :name="$t(item.field.label)"
                  :rules="item.field.rules"
                >
                  <label>
                    {{ $t(item.field.label) }}
                  </label>
                  <div>
                    <b-form-radio-group
                      id="result"
                      v-model="data[item.field.key]"
                      :name="item.field.key"
                      buttons
                      button-variant="outline-primary"
                    >
                      <b-form-radio
                        v-for="option in resultOptions"
                        :key="option.value"
                        :class="`fightResult-${getFightResultById(option.value)}`"
                        :value="option.value"
                      >
                        {{ $t(option.text) }}
                      </b-form-radio>
                    </b-form-radio-group>
                  </div>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </template>
          </n-input>
          <b-row>
            <b-col
              cols="12"
              class="text-right"
            >
              <n-button-loading
                v-if="$can('update', 'video-live-upload')"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                type="submit"
                variant="primary"
                class="mt-1 mr-1"
                :loading="loading"
                :disabled="invalid"
              >
                {{ $t("button.saveChanges") }}
              </n-button-loading>
              <n-button-loading
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                type="button"
                variant="outline-secondary"
                :loading="loading"
                class="mt-1"
                @submit="back"
              >
                {{ $t("button.back") }}
              </n-button-loading>
            </b-col>
          </b-row>
        </n-form-confirmation>
      </validation-observer>
    </b-card>
  </div>
</template>

<script>
import {
  BFormGroup,
  BRow,
  BCol,
  BCard,
  BFormRadioGroup, BFormRadio,
} from 'bootstrap-vue'
import Repository from '@/repositories/RepositoryFactory'
import Ripple from 'vue-ripple-directive'
import NButtonLoading from '@/components/NButtonLoading.vue'
import NFormConfirmation from '@/components/NFormConfirmation.vue'
import NInput from '@/components/NInput.vue'
import FormInput from './formInput'

const MatchVideoRepository = Repository.get('matchVideo')

export default {
  components: {
    BFormRadio,
    BFormGroup,
    BRow,
    BCol,
    BCard,
    BFormRadioGroup,
    NButtonLoading,
    NFormConfirmation,
    NInput,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      data: {
        channelId: null,
        result: null,
        betTime: null,
        fullTime: null,
        isEnable: true,
      },
      initData: {},
      loading: false,
    }
  },
  computed: {
    resultOptions() {
      return [
        { text: 'field.meron', value: 1 },
        { text: 'field.draw', value: 3 },
        { text: 'field.wala', value: 2 },
        { text: 'field.cancel', value: 4 },
      ]
    },
  },
  mounted() {
    this.show()
  },
  methods: {
    onChange(event, key, validate) {
      const { files } = event.target
      if (!files || !files.length) return

      const file = files[0]

      // Save the file in your data
      this.$set(this.data, key, {
        file,
        preview: URL.createObjectURL(file), // create preview URL
      })

      // Pass file to vee-validate
      validate(file)
    },
    getFightResultById(id) {
      if (id === 1) {
        return 'meron'
      } if (id === 2) {
        return 'wala'
      } if (id === 3) {
        return 'draw'
      } if (id === 4) {
        return 'cancel'
      }

      return ''
    },
    show() {
      MatchVideoRepository.show(this.$route.params.id).then(response => {
        this.initData = {
          ...response.data.data,
        }
      })
    },
    submit() {
      this.$refs.editForm.validate().then(success => {
        if (success) {
          this.loading = true

          const formData = new FormData()

          if (this.data.file) {
            formData.append('file', this.data.file.file)
          }
          formData.append('id', this.$route.params.id)
          formData.append('channel_id', this.data.channelId)
          formData.append('result', this.data.result)
          formData.append('bet_time', this.data.betTime)
          formData.append('full_time', this.data.fullTime)
          formData.append('is_enable', this.data.isEnable)

          MatchVideoRepository.update(formData)
            .then(response => {
              this.$router.push({
                name: 'view-match-video',
                params: { id: response.data.data.id },
              })
            })
            .catch(error => {
              if (error.response?.status === 422) {
                this.$refs.editForm.setErrors(error.response?.data?.errors)
              }
            })
            .then(() => {
              this.loading = false
            })
        }
      })
    },
    back() {
      this.$router.back()
    },
  },
  setup() {
    const fields = FormInput.map(value => {
      if (value.key === 'password' || value.key === 'retypePassword') {
        value.rules = value.rules.replace('required|', '')
        value.rules = value.rules.replace('required', '')
      }

      return value
    })

    return { fields }
  },
}
</script>
